import React, { useState, useEffect } from 'react';
import { getTemplates, updateNewPlan, deletePlan } from './../requests';
import Plan from './Plan';
import { getCurrentUser, getBrand, createNewPlan } from "New/serverRequests/requests";

import { useRouter } from 'next/router';

const Published = () => {
    const [render, setRender] = useState([]);
    const [dataMain, setDataMain] = useState([]);
    const [nowPage, setNowPage] = useState(1);
    const [activeEdit, setActiveEdit] = useState("");
    const [countPages, setCountPages] = useState(1);
    const [countPlans, setCountPlans] = useState(0);
    const [dataSearch, setDataSearch] = useState([]);
    const [searchText, setSearcheText] = useState("");
    const [displayDataPagination, setDisplayDataPagination] = useState({start:0, finish:0});
    const [currentUser, setCurrentUser] = useState({});
    const [templates, setTemplates] = useState([]);
    const [ copiedUrl, setCopiedUrl ] = useState("");
    const router = useRouter();
    const [refresh, setRefresh ] = useState(false);

    const loadCurrentUser = () => {
        getCurrentUser().then((result) => {
            setCurrentUser(result);
            if (result.pending_credits > 0) {
                setTimeout(() => {
                    loadCurrentUser();
                }, 5000)
            }
        });
    }

    useEffect(() => {
        loadCurrentUser();
        document.addEventListener('click', (e) => {
            if (e.target.className !== 'copy-btn') setCopiedUrl("");
        })
    },[]);

    useEffect(() => {
        loadCurrentUser();
    }, [refresh])

    const data_request = {user_id: currentUser.userid,}

    const Update = () => {
        getTemplates(data_request)
            .then(data=>{
                //init when page in upload
                const new_data = [];
                let new_templates = [];
                for(let i = 0; i < data.length; i++){
                    if(data[i].level[0] && data[i].template_name == ""){
                        new_data.push(data[i]);
                    }
                    if (data[i].template_name !== "") new_templates.push(data[i]);
                }
                new_templates.sort((t1, t2) => t2.start_live - t1.start_live)
                setRender([]);
                setCountPlans(new_data.length);
                setCountPages(Math.ceil(new_data.length / 10));
                setDataMain(new_data);
                setDataSearch(new_data);
                initPlans(new_data);
                setTemplates(new_templates);
            });
    }

    useEffect(()=>{
        setRender([]);
        const temp = [];
        const upLevel = nowPage * 10;
        const lowLevel = upLevel - 10;
        for(let i = 0; i < dataSearch.length; i++){
            if(i >= lowLevel && i <= upLevel - 1) {
                const expired_time_sec = dataSearch[i].end_live - parseInt(new Date().getTime() / 1000);
                const expire_time_days = parseInt(expired_time_sec / 60 / 60 / 24);
                temp.push(<Plan key={i}
                                data={dataSearch[i]}
                                setActive={setActiveEdit}
                                active={activeEdit === dataSearch[i].id ? true : false}
                                time={expire_time_days}
                                update={Update}
                                currentUser={currentUser}
                                copiedUrl={copiedUrl}
                                setCopiedUrl={setCopiedUrl}/>)
            }
        }
        setRender(temp);
    }, [activeEdit, copiedUrl]);

    const initPlans = (dataInput = [], search = false) => {
        const upLevel = nowPage * 10;
        const lowLevel = upLevel - 10;
        const temp = [];
        dataInput.sort(function(a,b){
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.end_live) - new Date(a.end_live);
        });
        dataInput.sort(function(a, b) {
            return (a.published === b.published)? 0 : a.published? 1 : -1;
        });

        for(let i = 0; i < dataInput.length; i++){
            if(i >= lowLevel && i <= upLevel - 1) {
                const expired_time_sec = dataInput[i].end_live - parseInt(new Date().getTime() / 1000);
                const expire_time_days = parseInt(expired_time_sec / 60 / 60 / 24);
                temp.push(<Plan key={i}
                                setActive={setActiveEdit}
                                active={activeEdit == dataInput[i].id ? true : false}
                                data={dataInput[i]}
                                time={expire_time_days}
                                update={Update}
                                currentUser={currentUser}
                                copiedUrl={copiedUrl}
                                setCopiedUrl={setCopiedUrl}
                                setRefresh={setRefresh}/>)
            }
        }
        setDisplayDataPagination({start: lowLevel + 1, finish: upLevel})
        setRender(temp);
    }

    const showAll = () => {
        const temp = [];

        for(let i = 0; i < dataSearch.length; i++){
                const expired_time_sec = dataSearch[i].end_live - parseInt(new Date().getTime() / 1000);
                const expire_time_days = parseInt(expired_time_sec / 60 / 60 / 24);
                temp.push(<Plan key={i}
                                setActive={setActiveEdit}
                                data={dataSearch[i]}
                                active={activeEdit == dataSearch[i].id ? true : false}
                                time={expire_time_days}
                                update={Update}
                                currentUser={currentUser}
                                copiedUrl={copiedUrl}
                                setCopiedUrl={setCopiedUrl}/>)
        }
        setRender(temp);
    }

    useEffect(()=>{
        const upLevel = nowPage * 10;
        const lowLevel = upLevel - 10;
        const temp = [];

        for(let i = 0; i < dataSearch.length; i++){
            if(i >= lowLevel && i <= upLevel - 1) {
                const expired_time_sec = dataSearch[i].end_live - parseInt(new Date().getTime() / 1000);
                const expire_time_days = parseInt(expired_time_sec / 60 / 60 / 24);
                temp.push(<Plan key={i}
                                setActive={setActiveEdit}
                                data={dataSearch[i]}
                                active={activeEdit == dataSearch[i].id ? true : false}
                                time={expire_time_days}
                                update={Update}
                                currentUser={currentUser}
                                copiedUrl={copiedUrl}
                                setCopiedUrl={setCopiedUrl}/>)
            }
        }
        setDisplayDataPagination({start: lowLevel + 1, finish: upLevel})
        setRender(temp);
    }, [nowPage]);

    useEffect(()=>{
        if(data_request.user_id){
            getTemplates(data_request)
            .then(data=>{
                //init when page in upload
                let new_templates = [];
                const new_data = [];
                for(let i = 0; i < data.length; i++){
                    if(data[i].level[0] && data[i].template_name === ""){
                        new_data.push(data[i]);
                    }
                    if (data[i].template_name !== "") new_templates.push(data[i]);
                }
                new_templates.sort((t1, t2) => t2.start_live - t1.start_live)
                setCountPlans(new_data.length);
                setCountPages(Math.ceil(new_data.length / 10));
                setDataMain(new_data);
                setDataSearch(new_data);
                initPlans(new_data);
                setTemplates(new_templates);
            });
        }
    }, [data_request.user_id, refresh])

    useEffect(()=>{
        const result = dataMain.filter(item =>
            item.address?.toLowerCase().includes(searchText?.toLowerCase())
        )
        setDataSearch(result);
        if(searchText === ""){
            initPlans(dataMain, true);
        } else {
            initPlans(result, true);
        }
    }, [searchText]);

    return(
        <div className="publ_wrap">
            {refresh ?
                <div className='refreshOverlay' onClick={() => setRefresh(false)}>
                    <h1 className='refresh-button'>Refresh this page for updates</h1>
                </div>
            : ''}
            <div className="start-btn">
                <button className='new'
                    onClick={() => {
                        window.open(window.location.href.replace(router.asPath, '/user/new'));
                        setRefresh(true);
                    }}>
                    Start new iFloorPlan
                </button>
                {templates.map((el, index) => (
                    <button key={index} className='template'
                    onClick={() => {
                        window.open(window.location.href.replace(router.asPath, `/user/new?template_id={${el.id}}`));
                        setRefresh(true);
                    }}>
                    {el.template_name}
                    </button>
                ))}
            </div>
            <div className="search">
                <i className="fas fa-search"></i>
                <input type="text"
                       placeholder='Search for...'
                       onChange={(event)=>{setSearcheText(event.target.value)}}/>
            </div>
            <div className="render">
                {render}
            </div>
            <div className="pagination">
                <button onClick={() => setNowPage(1)}>&lt;&lt;</button>
                <button onClick={() => setNowPage(nowPage == 1 ? nowPage : nowPage - 1)}>&lt; </button>
                <p>Page {nowPage} of {countPages} (Showing items {displayDataPagination.start} - {displayDataPagination.finish} of {countPlans})</p>
                <button onClick={() => setNowPage(nowPage == countPages ? nowPage : nowPage + 1)}>&gt;</button>
                <button onClick={() => setNowPage(countPages)}>&gt;&gt;</button>
                <button onClick={showAll}>Show all</button>
            </div>
        </div>
    )
}
export default Published;